import { Checkbox } from 'antd';
import classNames from 'classnames';
import { FC, memo } from 'react';
import './style.scss';
interface IProps {
    options?: IOptions[];
    field?: any;
    value?: any;
    onChange?: any;
    disabled?: boolean;
    direction?: 'row' | 'column';
    col?: number;
    addOnchange?: boolean;
    rowGap?: number;
}

interface IOptions {
    label?: string;
    value: number | string;
}

const CheckBoxGroupWrap: FC<IProps> = ({
    options,
    addOnchange = true,
    onChange,
    field,
    col = 2,
    direction,
    disabled,
    rowGap,
}) => {
    const newProps = {
        options,
        disabled,
        ...field,
        ...(addOnchange && { onChange }),
    };
    return (
        <Checkbox.Group
            style={{ '--col': col, 'rowGap': `${rowGap}px` }}
            className={classNames('checkboxgroup__wrap', { column: direction === 'column' })}
            {...newProps}
        />
    );
};

export default memo(CheckBoxGroupWrap);
